import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import classes from './ProfileCard.module.css';
import { getRgbFromColorName } from 'shared/utility';

const profileCard = (props) => {
  return (
    <div className={classes.ProfileCard} onClick={() => props.handleProfileEdit(props.user.UserId)}>
      {props.user.ImageURL && props.user.ImageURL.charAt(props.user.ImageURL.length - 1) !== '/' ? (
        <img
          style={{
            border: `4px solid${props.user.Color ? getRgbFromColorName(props.user.Color) : 'rgb(108 162 183)'}`,
          }}
          src={props.user.ImageURL}
          alt="profile"
          className={classes.ProfileThumb}
        />
      ) : (
        <FontAwesomeIcon
          style={{ color: props.user.Color ? getRgbFromColorName(props.user.Color) : 'hsl(0, 0%, 90%)' }}
          icon="user-circle"
          className={classes.UserIcon}
        />
      )}
      <p className={classes.Name}>
        <span className={classes.Label}>Name:</span>
        <span className={classes.Value}> {props.user.FullName}</span>
      </p>
    </div>
  );
};

export default profileCard;
